import gql from 'graphql-tag';

export default gql`
  subscription OnVPStatusChange($vpId: ID) {
    onVPStatusChange(vpId: $vpId) {
      vpId
      status
      vncEndpoint
      meetingId
      meetingName
      userId
      message
      updatedAt
    }
  }
`;
